// v2.6.0 — Modale d'estimation transport en commun (gbaka).
// Pas de routing transport temps réel : estimation OSRM driving × 1.4 + heuristique prix.

import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

export default function TransportEstimateModal({ open, destination, onClose }) {
  const [loading, setLoading] = useState(false);
  const [from, setFrom] = useState(null); // [lat,lng]
  const [estimate, setEstimate] = useState(null);
  const [err, setErr] = useState("");

  useEffect(() => {
    if (!open || !destination) return;
    setLoading(true);
    setEstimate(null);
    setErr("");

    const fetchEstimate = (fromLat, fromLng) => {
      setFrom([fromLat, fromLng]);
      fetch(`${API}/transport/estimate`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ from_lat: fromLat, from_lng: fromLng, to_lat: destination.lat, to_lng: destination.lng }),
      })
        .then((r) => r.json())
        .then((d) => {
          if (!d.ok) throw new Error(d.error || "estimation_failed");
          setEstimate(d.estimate);
        })
        .catch((e) => setErr(e.message))
        .finally(() => setLoading(false));
    };

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (p) => fetchEstimate(p.coords.latitude, p.coords.longitude),
        (_e) => fetchEstimate(5.3242, -4.0208), // fallback Plateau
        { enableHighAccuracy: false, timeout: 5000, maximumAge: 30000 },
      );
    } else {
      fetchEstimate(5.3242, -4.0208);
    }
  }, [open, destination]);

  if (!open) return null;

  const fmtDur = (s) => {
    if (s == null) return "—";
    const m = Math.round(s / 60);
    if (m < 60) return `${m} min`;
    return `${Math.floor(m / 60)}h ${m % 60}min`;
  };
  const fmtDist = (m) => (m == null ? "—" : m < 1000 ? `${m} m` : `${(m / 1000).toFixed(2)} km`);

  return (
    <div data-testid="transport-modal" style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,0.7)", zIndex: 100,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
    }} onClick={onClose}>
      <div onClick={(e) => e.stopPropagation()} style={{
        width: "100%", maxWidth: 440, background: "#0F172A", color: "#fff",
        borderRadius: 16, padding: 24, border: "1px solid rgba(255,255,255,0.12)",
        boxShadow: "0 24px 64px rgba(0,0,0,0.5)",
      }}>
        <h2 style={{ marginTop: 0, fontSize: 19 }}>🚐 Estimation transport en commun</h2>
        <div style={{ fontSize: 12, color: "#94a3b8", marginBottom: 16 }}>
          Vers <strong style={{ color: "#fff" }}>{destination?.name}</strong>
          {destination?.label && <> · <span>{destination.label}</span></>}
        </div>

        {loading && <div data-testid="transport-loading" style={{ color: "#94a3b8", fontSize: 13 }}>Calcul en cours…</div>}
        {err && <div data-testid="transport-error" style={{ color: "#fca5a5", fontSize: 13 }}>Erreur : {err}</div>}

        {estimate && (
          <div data-testid="transport-result">
            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 14 }}>
              <Stat label="Durée estimée" value={fmtDur(estimate.duration_transport_s)} highlight />
              <Stat label="Prix estimé" value={`${estimate.price_estimate_fcfa} FCFA`} highlight />
              <Stat label="Distance totale" value={fmtDist(estimate.distance_m)} />
              <Stat label="Changements" value={`${estimate.changes} ${estimate.changes === 1 ? "fois" : "fois"}`} />
            </div>
            <div style={{
              background: "rgba(245,158,11,0.1)", border: "1px solid rgba(245,158,11,0.3)",
              color: "#fbbf24", padding: 10, borderRadius: 8, fontSize: 11, marginBottom: 14,
            }}>
              ⚠️ Estimation indicative basée sur durée routière × 1.4. Pas de routing
              transport temps réel disponible pour Abidjan.
            </div>
            {from && (
              <div style={{ fontSize: 10, color: "#64748b", marginBottom: 14 }}>
                Depuis : {from[0].toFixed(4)}, {from[1].toFixed(4)}
                {estimate.routing_status === "fallback" && <> · <span style={{ color: "#f59e0b" }}>OSRM indisponible, ligne droite</span></>}
              </div>
            )}
          </div>
        )}

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <button onClick={onClose} data-testid="transport-close" style={{
            background: "#3B82F6", color: "#fff", border: "none", padding: "8px 18px",
            borderRadius: 6, cursor: "pointer", fontWeight: 600,
          }}>Fermer</button>
        </div>
      </div>
    </div>
  );
}

function Stat({ label, value, highlight }) {
  return (
    <div style={{
      background: "rgba(255,255,255,0.04)", border: "1px solid rgba(255,255,255,0.08)",
      borderRadius: 8, padding: 10,
    }}>
      <div style={{ fontSize: 10, color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.5 }}>{label}</div>
      <div style={{ fontSize: highlight ? 18 : 14, fontWeight: 600, marginTop: 4 }}>{value}</div>
    </div>
  );
}
